import { sort } from 'rambda';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLoaderData } from 'react-router';
import { Virtuoso } from 'react-virtuoso';
import { ContactListItem } from '@/components/contacts/contact-list/contact-list-item';
import EmptyLayout from '@/components/layouts/empty-layout';
import AppHeaderMenu from '@/components/layouts/page-layout/app-header-menu';
import PageLayout from '@/components/layouts/page-layout/page-layout';
import LoadingLayout from '@/components/layouts/progress-layout/loading-layout';
import useGroups from '@/hooks/contacts/use-groups';
import { useIsDesktop } from '@/hooks/use-user-platform';
import ROUTES, { type PromiseLoaderReturnType } from '@/routes';

export default function ContactGroupsIndexRoute() {
  const loaderData = useLoaderData<PromiseLoaderReturnType>();
  const { t } = useTranslation();
  const isDesktop = useIsDesktop();
  const { groups } = useGroups();

  const sortedGroups = useMemo(() => sort((a, b) => a.Order - b.Order, Object.values(groups)), [groups]);

  return (
    <PageLayout
      title={t('contact.groups.title')}
      headerConfig={{
        navigateBack: !isDesktop,
        actions: !isDesktop ? <AppHeaderMenu /> : null,
      }}>
      <LoadingLayout promise={loaderData?.promises}>
        {() => (
          <Virtuoso
            className='flex flex-1 flex-col items-stretch'
            data={sortedGroups}
            overscan={6}
            defaultItemHeight={56}
            increaseViewportBy={168}
            components={{
              EmptyPlaceholder: () => <EmptyLayout label='contact.groups.empty' />,
            }}
            itemContent={(_, group) => (
              <Link
                key={group.ID}
                to={ROUTES.MESSAGES.GROUPS.$buildPath({ params: { id: group.ID } })}>
                <ContactListItem
                  item={group}
                  arrow
                />
              </Link>
            )}
          />
        )}
      </LoadingLayout>
    </PageLayout>
  );
}
